module.exports = __webpack_public_path__ + "static/img/3389_phase_function_Paper_PointsHejduk_Prediction.4276bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3389_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7wxU
// module chunks = 0